module.exports = __webpack_public_path__ + "static/media/imzaposLogoBeyaz.00eb8a0f.png";